var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view',{attrs:{"searchInp":_vm.searchInp},on:{"update:searchInp":_vm.getSearch}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }